import { parseStringPromise } from 'xml2js'
import captionStatusTypes from 'helpers/enums/interactiveVideo/captionStatusTypes'
import textTrackTypes from 'helpers/enums/interactiveVideo/textTrackTypes'

function xmlResponseToJson(xml) {
	const options = {
		attrkey: 'data',
	}
	const jsonData = parseStringPromise(xml, options)
		.then(jsonResult => (
			jsonResult
		))

	return jsonData
}

async function youtubeCaptionsFormatter(videoCaptions, videoId) {
	const jsonCaptionsData = await xmlResponseToJson(videoCaptions.text)

	return jsonCaptionsData.transcript_list.track.reduce((captions, captionTrack) => {
		//if language already exists then don't add to list
		if (!captions.find(caption => caption.srclang === captionTrack.data.lang_code)) {
			const srclang = captionTrack.data.lang_code
			const trackName = captionTrack.data.name ? `&name=${captionTrack.data.name}` : ''
			const captionObject = {
				kind: textTrackTypes.CAPTIONS,
				srclang,
				label: captionTrack.data.lang_translated,
				src: `https://video.google.com/timedtext?lang=${srclang}&v=${videoId}&fmt=vtt${trackName}`,
				mode: captionStatusTypes.DISABLED,
				isDefault: !!captionTrack.data.lang_default,
			}
			captions.push(captionObject)
		}
		return captions
	}, []
	)
}

export default youtubeCaptionsFormatter
